import React from "react";


export class BackgroundInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state =
            {
                curr_page:0,
                max_pages: props.background_pages.length-1
            }


        this.nextPageClicked = this.nextPageClicked.bind(this);
        this.prevPageClicked = this.prevPageClicked.bind(this);
        this.closeClicked = this.closeClicked.bind(this);

        console.log("show");
    }

    nextPageClicked()
    {
        this.setState({
            curr_page : (this.state.curr_page+1)
        });
    }

    prevPageClicked()
    {
        this.setState({
            curr_page : (this.state.curr_page-1)
        });
    }

    closeClicked()
    {
        window.app.closeBackgroundInfoClicked();
    }

    render() {
        return (
            <div className={"tool__backgroundinfo__wrapper"}>
                <div className={"tool__backgroundinfo__header"} >
                    <h2>Achtergrondinformatie</h2>
                    <a href="javascript:void(0);" onClick={this.closeClicked}><img src={"/digibord/assets/svgs/popup_close_btn.svg"} className="tool__backgroundinfo__popup_close_btn" alt="Terug" /></a>
                </div>
                 <div className={"tool__backgroundinfo__content"} >

                    <div dangerouslySetInnerHTML={{__html: this.props.background_pages[this.state.curr_page]}}></div>

                 </div>

                <div className={"tool__backgroundinfonavbar__wrapper"}>


                    { (this.state.curr_page > 0  ) &&
                        (
                            <a href="javascript:void(0);" onClick={this.prevPageClicked}><img src={"/digibord/assets/svgs/terug_btn.svg"} className="tool__backgroundinfonavbar__terug_btn" alt="Terug"/></a>
                        )}

                    { (this.state.curr_page+1 < this.state.max_pages)  &&
                        (

                            <a href="javascript:void(0);" onClick={this.nextPageClicked}><img src={"/digibord/assets/svgs/verder_btn.svg"} className="tool__backgroundinfonavbar__verder_btn" alt="Verder"/></a>
                        )}



                </div>
            </div>
        )
    }
}
